import { SignIn, SignUp } from "@clerk/react";

export function AdminSignInPage() {
  return (
    <div className="min-h-screen bg-[#FAF9F6] grid lg:grid-cols-2">
      <div className="hidden lg:flex mlobox-gradient text-white p-12 flex-col justify-between">
        <div>
          <div className="flex items-center gap-2">
            <img src="/logo192.png" alt="MLOBOX logo" className="h-12 w-12 rounded-xl shadow-md ring-2 ring-white/30" />
            <div className="font-display font-extrabold text-2xl">MLOBOX</div>
          </div>
          <p className="mt-10 font-display text-4xl font-extrabold leading-tight">Admin console<br/>for your kitchen.</p>
          <p className="mt-4 text-white/90 max-w-md">Manage orders live, update delivery status, and keep your menu fresh — all from one screen.</p>
        </div>
        <div className="text-xs text-white/70">© MLOBOX Nairobi</div>
      </div>
      <div className="flex items-center justify-center p-6">
        <SignIn routing="path" path="/admin/sign-in" signUpUrl="/admin/sign-up" withSignUp />
      </div>
    </div>
  );
}

export function AdminSignUpPage() {
  return (
    <div className="min-h-screen bg-[#FAF9F6] grid lg:grid-cols-2">
      <div className="hidden lg:flex mlobox-gradient text-white p-12 flex-col justify-between">
        <div>
          <div className="flex items-center gap-2">
            <img src="/logo192.png" alt="MLOBOX logo" className="h-12 w-12 rounded-xl shadow-md ring-2 ring-white/30" />
            <div className="font-display font-extrabold text-2xl">MLOBOX</div>
          </div>
          <p className="mt-10 font-display text-4xl font-extrabold leading-tight">Create your<br/>admin account.</p>
        </div>
        <div className="text-xs text-white/70">© MLOBOX Nairobi</div>
      </div>
      <div className="flex items-center justify-center p-6">
        <SignUp routing="path" path="/admin/sign-up" signInUrl="/admin/sign-in" />
      </div>
    </div>
  );
}
